import { transXSS } from '../../common/js/util'

/**
 * 抽离localStorage,以防兼容性问题
 */
const storage = {
    getItem: (key) => {

        return localStorage.getItem(key);

    },
    setItem: (key, value) => {
        localStorage.setItem(key, value);
    }
}

// 最近搜索记录 -- 获取， 增加， 删除
const recentSearch = {
    storeKey: 'header-search-logs',
    get: function (nums) {

        let items = transXSS(storage.getItem(this.storeKey));

        items = items && items.split(',').slice(-nums); // 最近搜索条目5条

        // 组装最近搜索的数据
        return items
            ? [{ renderType: 'title', text: '最近搜索' }]
                .concat(items.map(function (text) {

                    return { renderType: 'log', text: text }

                }).reverse())
            : [];

    },
    add: function (text) {

        let items = transXSS(storage.getItem(this.storeKey));

        items = items ? items.split(',') : [];
        if (text && items.indexOf(text) === -1) {

            items.push(text);

        }

        storage.setItem(this.storeKey, items.join(','));

    },
    remove: function (text) {

        let items = transXSS(storage.getItem(this.storeKey)).split(',');
        let index = items.indexOf(text);

        if (index >= 0) {

            items.splice(index, 1);
            storage.setItem(this.storeKey, items.join(','));

        }

    }
};

export default recentSearch;




// WEBPACK FOOTER //
// ./modules/logo-input/js/storage.js